import { Component, OnInit } from '@angular/core';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { UserDisplay, MemberManagementService, UserStats, MemberSearchParams } from '../user-management.service';
import { PageResponse } from '../base-capacitor-http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'user-management',
  standalone: true,
  imports:[CommonModule, FormsModule, MatPaginatorModule],
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})
export class UserManagementComponent implements OnInit {


  page: PageResponse<UserDisplay> = new PageResponse<UserDisplay>;
  params: MemberSearchParams = new MemberSearchParams();
  pageSizeOptions = [5, 10, 25];
  userStats: UserStats;
  bulkAction: boolean = false;
  modal: boolean = false;
  modalText: string;
  search: string = null;
  statusFilter: string = '';
  roleFilter: string = '';
  action: string = '';
  selectedUser: UserDisplay;
  private emailCheckTimeout: any;
  private usernameTimeout: any;
  emailExists: boolean = false;
  usernameExists: boolean = false;

  constructor(private userManagementService: MemberManagementService) {

  }

  getAvatar(user: UserDisplay) {
    return user.username[0].toUpperCase() + user.username[1].toUpperCase();
  }

  selectAll() {
    this.page.data.forEach(user => {
      user.selected = !this.bulkAction;
    })
  }

  getSelectedCount() {
    return this.page.data.filter(member => { return member.selected === true }).length || 0;
  }

  async checkUsernameExists() {
    clearTimeout(this.usernameTimeout);
    this.usernameTimeout = setTimeout(async () => {
      this.usernameExists = await this.userManagementService.checkUsernameExists(this.selectedUser.username);
    }, 500);
  }

  async checkEmailExists() {
    clearTimeout(this.emailCheckTimeout);
    this.emailCheckTimeout = setTimeout(async () => {
      this.emailExists = await this.userManagementService.checkEmailExists(this.selectedUser.email);
    }, 500);
  }

  async saveUser() {
    if (this.selectedUser.id) {
      const user = this.page.data.find(user => user.id === this.selectedUser.id);
      const index = this.page.data.indexOf(user);
      const result = await this.userManagementService.updateMember(this.selectedUser);
      this.page.data[index] = result;
      return;
    }
    const result = await this.userManagementService.registerMember(this.selectedUser);
    if (result) {
      this.modal = false;
      this.userManagementService
      return;
    }

  }

  clearSearchFilter() {
    this.statusFilter = '';
    this.roleFilter = '';
  }

  async applyBulkAction() {
    const selectedUsers = this.page.data.filter(user => { return user.selected === true; });
    switch (this.action) {
      case 'enable':
        selectedUsers.forEach(user => { user.disabled = false; });
        this.userManagementService.bulkUpdate('enable', selectedUsers);
        break;
      case 'disable':
        selectedUsers.forEach(user => { user.disabled = true; });
        this.userManagementService.bulkUpdate('disable', selectedUsers);
        break;
      case 'delete':
        this.userManagementService.bulkUpdate('delete', selectedUsers);
        break;
      default:
        break;
    }
  }

  async searchUsers() {
    let verified: boolean = false;
    let disabled: boolean = false;
    switch (this.statusFilter) {
      case 'active':
        verified = true;
        disabled = true;
        break;
      case 'verified':
        verified = true;
        break;
      case 'disabled':
        disabled = true;
        break;
      default:
        verified = null;
        disabled = null;
        break;
    }

    this.page = await this.userManagementService.getAllMemberData(this.params);
  }

  async handlePageEvent(e: PageEvent) {
    this.params.size = e.pageSize;
    this.params.page = e.pageIndex;
    this.loadPageData();
  }

  async loadPageData() {
    this.page = await this.userManagementService.getAllMemberData(this.params);
  }

  openModal() {
    this.modal = true;
    this.modalText = 'Add new user';
  }

  closeModal() {
    this.modal = false;
    this.selectedUser = new UserDisplay();
  }

  editUser(index: number) {
    this.modal = true;
    this.modalText = 'Edit user';
    this.selectedUser = this.page.data[index];
  }

  async toggleUserStatus(index: number) {
    let member = this.page.data[index];
    if (member.disabled === true) {
      member.disabled = false;
    } else {
      member.disabled = true;
    }

    member = await this.userManagementService.updateMember(member);
    this.page.data[index] = member;
  }

  async deleteUser(index: number) {
    const member = this.page.data[index];
    const result = await this.userManagementService.deleteMember(member.id);
    if (result) {
      this.page.data.splice(index, 1);
    }
  }

  async ngOnInit(): Promise<void> {
    this.page = new PageResponse();
    this.selectedUser = new UserDisplay();
    this.userStats = await this.userManagementService.getUserStats();
    this.loadPageData();
  }
}
